module.exports = __webpack_public_path__ + "img/heart.8d23be79.png";